import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: Country required
 */
export class PaisRequeridoPonderarParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Country required");
    }

    public traducir(): string {
        return "Se necesita el país para ponderar usuarios";
    }
}
